export function getCurrentYear() {
    const year = new Date().getFullYear();
    return year.toString();
}
